import { render, staticRenderFns } from "./shou.vue?vue&type=template&id=8307584e&"
import script from "./shou.vue?vue&type=script&lang=ts&"
export * from "./shou.vue?vue&type=script&lang=ts&"
import style0 from "./shou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports